import EmployerForm from "@/components/EmployerForm";
import CandidateForm from "@/components/CandidateForm";

export default function DualRoutingSection() {
  return (
    <section className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16">
        <div id="employers" data-testid="employers-section">
          <div className="text-xs uppercase tracking-[0.2em] text-blue-600 font-semibold">
            For Employers
          </div>
          <h2 className="font-display font-bold mt-3 text-3xl sm:text-4xl tracking-tight text-slate-900">
            Submit a role. Get a shortlist in 5 days.
          </h2>
          <p className="mt-4 text-slate-600">
            Tell us what you're hiring for. Our AI matches against 180,000+
            vetted European engineers; a senior recruiter validates every
            shortlist before you see it.
          </p>
          <div className="mt-6">
            <EmployerForm />
          </div>
        </div>

        <div id="candidates" data-testid="candidates-section">
          <div className="text-xs uppercase tracking-[0.2em] text-teal-700 font-semibold">
            For Candidates
          </div>
          <h2 className="font-display font-bold mt-3 text-3xl sm:text-4xl tracking-tight text-slate-900">
            Upload your CV. We'll do the rest.
          </h2>
          <p className="mt-4 text-slate-600">
            Apply once — get matched continuously with relevant roles across
            Germany, Netherlands, Romania, Poland, Bulgaria and Remote Europe.
            GDPR compliant. Your data is never shared without consent.
          </p>
          <div className="mt-6">
            <CandidateForm />
          </div>
        </div>
      </div>
    </section>
  );
}
